import api from "../api";

export const CreateNewSFDCObject = async (objectType: any, data: any) => {
	return await api.post("/create_new_sfdc_object", {
		pod_user_id: Number(localStorage.getItem("podUserId")),
		objectType,
		data,
	});
};
